import React from "react";
import { Navigate } from "react-router-dom";

const HelperRedirect = () => {
  //   "";
  return <Navigate to={`/admin/authenticate`} />;
};

export default HelperRedirect;
